import React, { FC } from 'react';

import { Badge, BadgeProps } from '@mantine/core';

import { CompanyProfile, CompanySubscription, SubscriptionType } from 'models';
import { SubscriptionHelpers } from 'helpers/SubscriptionHelpers';

import { useTeam } from 'hooks/use-team';

const SubscriptionBadge: FC<{ company: CompanyProfile } & BadgeProps> = ({ company, ...props }) => {
    const { team } = useTeam(company.team);

    if (!team) {
        return null;
    }

    const subscription = SubscriptionHelpers.getSubscriptionData(
        SubscriptionType.COMPANY,
        team.subscriptions,
    ).subscription;

    return (
        <Badge color={subscription === CompanySubscription.PREMIUM ? 'green' : 'red'} size="sm" {...props}>
            {subscription === CompanySubscription.PREMIUM ? 'Premium profile' : 'Free profile'}
        </Badge>
    );
};

export { SubscriptionBadge };
